import React from 'react';
import { Box, Container, Typography, Grid, Paper, Button, IconButton, Stack, Divider, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useCart } from '../Context/CartContext';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
    const { cart, removeFromCart, updateQuantity, clearCart } = useCart();
    const navigate = useNavigate();

    const handleEnquire = () => {
        const cartDetails = cart.map(item => {
            const modelInfo = item.model ? ` (Model: ${item.model.model})` : '';
            return `- ${item.title}${modelInfo} x ${item.quantity}`;
        }).join('\n');

        const requirement = `I am interested in the following items:\n\n${cartDetails}`;
        navigate('/Enquiry', { state: { requirement } });
    };

    if (cart.length === 0) {
        return (
            <Container sx={{ py: 8, textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="h4" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, mb: 2, color: '#333' }}>
                    Your Cart is Empty
                </Typography>
                <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                    Looks like you haven't added any items yet.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/Products')}
                    sx={{ backgroundColor: '#7C001F', '&:hover': { backgroundColor: '#5C001F' } }}
                >
                    Browse Products
                </Button>
            </Container>
        );
    }

    return (
        <Box sx={{ backgroundColor: "#f9f9f9", minHeight: "100vh", py: 4 }}>
            <Container maxWidth="lg">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(-1)}
                    sx={{
                        color: "#7C001F",
                        mb: 3,
                        fontWeight: 600,
                        '&:hover': { backgroundColor: 'rgba(124, 0, 31, 0.05)' }
                    }}
                >
                    Back
                </Button>

                <Typography variant="h4" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, mb: 4, color: '#1a1a1a' }}>
                    Your Cart ({cart.length} items)
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Stack spacing={3}>
                            {cart.map((item, index) => (
                                <Paper key={index} elevation={0} sx={{ p: 3, borderRadius: '16px', border: '1px solid #eee' }}>
                                    <Grid container spacing={3} alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Box
                                                component="img"
                                                src={item.image}
                                                alt={item.title}
                                                sx={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'contain', maxHeight: '120px' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={5}>
                                            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#333' }}>
                                                {item.title}
                                            </Typography>
                                            {item.model && (
                                                <Typography variant="body2" sx={{ color: '#666', mt: 0.5 }}>
                                                    Model: {item.model.model}
                                                </Typography>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                                                <TextField
                                                    type="number"
                                                    label="Qty"
                                                    size="small"
                                                    value={item.quantity}
                                                    onChange={(e) => updateQuantity(item.id, item.model ? item.model.model : null, parseInt(e.target.value))}
                                                    inputProps={{ min: 1 }}
                                                    sx={{ width: '80px' }}
                                                />
                                                <IconButton
                                                    onClick={() => removeFromCart(item.id, item.model ? item.model.model : null)}
                                                    color="error"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            ))}
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ p: 3, borderRadius: '16px', border: '1px solid #eee', position: 'sticky', top: '100px' }}>
                            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, mb: 3 }}>
                                Summary
                            </Typography>
                            <Divider sx={{ mb: 3 }} />
                            <Typography variant="body1" sx={{ mb: 3, color: '#555' }}>
                                Ready to proceed? Click below to send an enquiry for these items.
                            </Typography>
                            <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                onClick={handleEnquire}
                                sx={{
                                    backgroundColor: '#7C001F',
                                    color: 'white',
                                    py: 1.5,
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    '&:hover': { backgroundColor: '#5C001F' }
                                }}
                            >
                                Enquire Now
                            </Button>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Cart;
